module.exports = __webpack_public_path__ + "img/photo-1.4ba9c41a.jpg";